import {lazy} from 'react';

const PrivacyPolicy = lazy(() => import('./PrivacyPolicy'));

export default PrivacyPolicy;
